import { sortCaret } from "../../../../../_metronic/_helpers";
import * as columnFormatters from "./student-report-table/column-formatters";

export const defaultSorted = [{ dataField: "id", order: "asc" }];
export const sizePerPageList = [
  { text: "10", page: 10 },
  { text: "25", page: 25 },
  { text: "50", page: 50 },
  { text: "100", page: 100 }
];
export const initialFilter = {
  filter: {
    identityCard: {}
  },
  sortOrder: "asc", // asc||desc
  sortField: "section",
  pageNumber: 1,
  pageSize: 10
};
// Initial table columns
export const initialColumns = [
  {
    dataField: "photoStr",
    text: "Fotoğraf",
    formatter: columnFormatters.PhotoColumnFormatter,
    style: {
      minWidth: "100px"
    }
  },
  {
    dataField: "studentNumber",
    text: "Öğrenci Numarası",
    sort: true,
    width: 20,
    sortCaret: sortCaret,
    style: {
      minWidth: "180px"
    }
  },
  {
    dataField: "identityCard.tcKimlikNo",
    text: "TC Kimlik No",
    sort: true,
    width: 20,
    sortCaret: sortCaret,
    style: {
      minWidth: "150px"
    }
  },
  {
    dataField: "identityCard.name",
    text: "Adı",
    sort: true,
    width: 25,
    sortCaret: sortCaret,
    style: {
      minWidth: "135px"
    }
  },
  {
    dataField: "identityCard.surname",
    text: "Soyadı",
    sort: true,
    width: 25,
    sortCaret: sortCaret,
    style: {
      minWidth: "135px"
    }
  },  
  {
    dataField: "sexName",
    text: "Cinsiyeti",
    sort: true,
    width: 20,
    sortCaret: sortCaret,
    style: {
      minWidth: "120px"
    }
  },
  {
    dataField: "gradeLevelName",
    text: "Sınıf Düzeyi",
    sort: true,
    width: 20,
    sortCaret: sortCaret,
    style: {
      minWidth: "140px"
    }
  },
  {
    dataField: "section",
    text: "Şube",
    sort: true,
    width: 20,
    sortCaret: sortCaret,
    style: {
      minWidth: "120px"
    }
  },
  {
    dataField: "phone",
    text: "Telefon",
    sort: true,
    width: 20,
    sortCaret: sortCaret,
    style: {
      minWidth: "175px"
    }
  },
  {
    dataField: "email",
    text: "Email",
    sort: true,
    width: 20,
    hidden: true,
    sortCaret: sortCaret,
    style: {
      minWidth: "120px"
    }
  },
  {
    dataField: "identityCard.birthDate",
    text: "Doğum Tarihi",
    sort: true,
    width: 20,
    hidden: true,
    sortCaret: sortCaret,
    style: {
      minWidth: "150px"
    }
  },
  {
    dataField: "registrationInfo.registrationStatusName",
    text: "Kayıt Durumu",
    sort: true,
    width: 40,
    hidden: true,
    sortCaret: sortCaret,
    style: {
      minWidth: "150px"
    }
  },
  {
    dataField: "registrationNo",
    text: "Kayıt Sıra No",
    sort: true,
    width: 40,
    hidden: true,
    sortCaret: sortCaret,
    style: {
      minWidth: "150px"
    }
  },
  {
    dataField: "registrationDate",
    text: "Kayıt Tarihi",
    sort: true,
    width: 40,
    hidden: true,
    sortCaret: sortCaret,
    style: {
      minWidth: "150px"
    }
  },
  {
    dataField: "theSchoolWhereComeFrom",
    text: "Geldiği Okul",
    sort: true,
    width: 40,
    hidden: true,
    sortCaret: sortCaret,
    style: {
      minWidth: "150px"
    }
  },
  {
    dataField: "registrationInfo.willUseCafeteria",
    text: "Yemekhane",
    sort: true,
    width: 40,
    hidden: true,
    sortCaret: sortCaret,
    formatter: (cell, row) => (row.registrationInfo.willUseCafeteria ? "Kullanacak" : "Kullanmayacak"),
    style: {
      minWidth: "150px"
    }
  },
  {
    dataField: "registrationInfo.transportationUsageName",
    text: "Servis Bilgileri",
    sort: true,
    width: 40,
    hidden: true,
    sortCaret: sortCaret,
    style: {
      minWidth: "160px"
    }
  },  
  {
    dataField: "advisors",
    text: "Danışman Öğretmenler",
    sort: true,
    width: 30,
    hidden: true,
    sortCaret: sortCaret,
    style: {
      minWidth: "225px"
    }
  },
  {
    dataField: "father.tcKimlikNo",
    text: "Baba TC Kimlik No",
    sort: true,
    width: 30,
    hidden: true,
    sortCaret: sortCaret,
    style: {
      minWidth: "180px"
    }
  },
  {
    dataField: "father.name",
    text: "Baba Adı Soyadı",
    sort: true,
    width: 30,
    hidden: true,
    sortCaret: sortCaret,
    style: {
      minWidth: "180px"
    }
  },
  {
    dataField: "father.occupation",
    text: "Baba Mesleği",
    sort: true,
    width: 20,
    hidden: true,
    sortCaret: sortCaret,
    style: {
      minWidth: "150px"
    }
  },
  {
    dataField: "father.occupationCategoryName",
    text: "Baba Meslek Kategorisi",
    sort: true,
    width: 20,
    hidden: true,
    sortCaret: sortCaret,
    style: {
      minWidth: "225px"
    }
  },
  {
    dataField: "father.workAddress.address1",
    text: "Baba İş Adresi",
    sort: true,
    width: 40,
    hidden: true,
    sortCaret: sortCaret,
    style: {
      minWidth: "250px"
    }
  },
  {
    dataField: "father.phone1",
    text: "Baba Telefon",
    sort: true,
    width: 20,
    hidden: true,
    sortCaret: sortCaret,
    style: {
      minWidth: "175px"
    }
  },
  {
    dataField: "father.email",
    text: "Baba Email",
    sort: true,
    width: 20,
    hidden: true,
    sortCaret: sortCaret,
    style: {
      minWidth: "120px"
    }
  },
  {
    dataField: "mother.tcKimlikNo",
    text: "Anne TC Kimlik No",
    sort: true,
    width: 30,
    hidden: true,
    sortCaret: sortCaret,
    style: {
      minWidth: "180px"
    }
  },
  {
    dataField: "mother.name",
    text: "Anne Adı Soyadı",
    sort: true,
    width: 30,
    hidden: true,
    sortCaret: sortCaret,
    style: {
      minWidth: "180px"
    }
  },
  {
    dataField: "mother.occupation",
    text: "Anne Mesleği",
    sort: true,
    width: 20,
    hidden: true,
    sortCaret: sortCaret,
    style: {
      minWidth: "150px"
    }
  },
  {
    dataField: "mother.occupationCategoryName",
    text: "Anne Meslek Kategorisi",
    sort: true,
    width: 20,
    hidden: true,
    sortCaret: sortCaret,
    style: {
      minWidth: "225px"
    }
  },
  {
    dataField: "mother.workAddress.address1",
    text: "Anne İş Adresi",
    sort: true,
    width: 40,
    hidden: true,
    sortCaret: sortCaret,
    style: {
      minWidth: "250px"
    }
  },
  {
    dataField: "mother.phone1",
    text: "Anne Telefon",
    sort: true,
    width: 20,
    hidden: true,
    sortCaret: sortCaret,
    style: {
      minWidth: "175px"
    }
  },
  {
    dataField: "mother.email",
    text: "Anne Email",
    sort: true,
    width: 20,
    hidden: true,
    sortCaret: sortCaret,
    style: {
      minWidth: "120px"
    }
  },
  {
    dataField: "parentRelationship",
    text: "Veli Yakınlığı",
    sort: true,
    width: 30,
    hidden: true,
    sortCaret: sortCaret,
    style: {
      minWidth: "150px"
    }
  },
  {
    dataField: "other.tcKimlikNo",
    text: "Veli TC Kimlik No",
    sort: true,
    width: 30,
    hidden: true,
    sortCaret: sortCaret,
    style: {
      minWidth: "180px"
    }
  },
  {
    dataField: "other.name",
    text: "Veli Adı Soyadı",
    sort: true,
    width: 30,
    hidden: true,
    sortCaret: sortCaret,
    style: {
      minWidth: "180px"
    }
  },
  {
    dataField: "other.occupation",
    text: "Veli Mesleği",
    sort: true,
    width: 20,
    hidden: true,
    sortCaret: sortCaret,
    style: {
      minWidth: "150px"
    }
  },
  {
    dataField: "other.occupationCategoryName",
    text: "Veli Meslek Kategorisi",
    sort: true,
    width: 20,
    hidden: true,
    sortCaret: sortCaret,
    style: {
      minWidth: "225px"
    }
  },
  {
    dataField: "other.homeAddress.address1",
    text: "Veli Adresi",
    sort: true,
    width: 40,
    hidden: true,
    sortCaret: sortCaret,
    style: {
      minWidth: "250px"
    }
  },
  {
    dataField: "other.phone1",
    text: "Veli Telefon",
    sort: true,
    width: 20,
    hidden: true,
    sortCaret: sortCaret,
    style: {
      minWidth: "175px"
    }
  },
  {
    dataField: "other.email",
    text: "Veli Email",
    sort: true,
    width: 20,
    hidden: true,
    sortCaret: sortCaret,
    style: {
      minWidth: "120px"
    }
  },
  {
    dataField: "registrationInfo.bougthUniform",
    text: "Kıyafet Bilgileri",
    sort: true,
    width: 40,
    hidden: true,
    sortCaret: sortCaret,
    formatter: (cell, row) => (row.registrationInfo.bougthUniform ? "Kıyafet Aldı" : "Kıyafet Almadı"),
    style: {
      minWidth: "175px"
    }
  },
  {
    dataField: "registrationInfo.uniformExplanation",
    text: "Kıyafet Açıklama",
    sort: true,
    width: 40,
    hidden: true,
    sortCaret: sortCaret,
    style: {
      minWidth: "250px"
    }
  },
  {
    dataField: "registrationInfo.bougthBook",
    text: "Kitap Durumu",
    sort: true,
    width: 40,
    hidden: true,
    sortCaret: sortCaret,
    formatter: (cell, row) => (row.registrationInfo.bougthBook ? "Kitap Aldı" : "Kitap Almadı"),
    style: {
      minWidth: "175px"
    }
  },
  {
    dataField: "registrationInfo.bookExplanation",
    text: "Kitap Açıklama",
    sort: true,
    width: 40,
    hidden: true,
    sortCaret: sortCaret,
    style: {
      minWidth: "250px"
    }
  },
  {
    dataField: "registrationInfo.registrationNote",
    text: "Öğrenci Açıklama",
    sort: true,
    width: 40,
    hidden: true,
    sortCaret: sortCaret,
    style: {
      minWidth: "300px"
    }
  }
];